// O SELO CONTA MENSAGEM, NÃO PASSO (24/10/2026). O Marcio recebeu o 1º toque e o selo dizia
// "3/3": dois passos tinham sido pulados sem enviar. `toques_enviados` são as mensagens que a
// pessoa recebeu; `toques_previstos`, essas mais as que ainda podem sair (o servidor calcula).
// Resposta antiga, sem os campos: cai no passo, como antes.
export const toquesDoFollowUp = run => {
  if (!run) return { enviados: 0, total: 0, porcento: 0 };
  const total = run.toques_previstos ?? run.total_steps ?? 0;
  const enviados =
    run.toques_enviados ?? Math.min(run.current_step || 0, total);
  const porcento = total ? Math.min(100, (enviados / total) * 100) : 0;
  return { enviados, total, porcento };
};
